export const validation = {
	title_es: 'required|min:3|max:255',
	content_es: 'min:1',
	excerpt_es: 'min:1',
	tags_es: 'min:1',
	title_en: 'required|min:3|max:255',
	content_en: 'min:1',
	excerpt_en: 'min:1',
	tags_en: 'min:1',
	title_it: 'required|min:3|max:255',
	content_it: 'min:1',
	excerpt_it: 'min:1',
	tags_it: 'min:1',
	title_fr: 'required|min:3|max:255',
	content_fr: 'min:1',
	excerpt_fr: 'min:1',
	tags_fr: 'min:1',
	title_pt: 'required|min:3|max:255',
	content_pt: 'min:1',
	excerpt_pt: 'min:1',
	tags_pt: 'min:1',
	title_de: 'required|min:3|max:255',
	content_de: 'min:1',
	excerpt_de: 'min:1',
	tags_de: 'min:1',
	status_id: 'required|numeric|min_value:1|max:2',
	url: 'url',
	date_published: 'date_format:YYYY-MM-DD',
	author_id: 'required|numeric|min_value:1|max:11',
	category_id: 'numeric|min_value:1|required|max:11'
}

export const Fields = function() {
	return {
		title_es: null,
		excerpt_es: null,
		tags_es: null,
		content_es: null,
		title_en: null,
		excerpt_en: null,
		tags_en: null,
		content_en: null,
		title_it: null,
		excerpt_it: null,
		tags_it: null,
		content_it: null,
		title_fr: null,
		excerpt_fr: null,
		tags_fr: null,
		content_fr: null,
		title_pt: null,
		excerpt_pt: null,
		tags_pt: null,
		content_pt: null,
		title_de: null,
		excerpt_de: null,
		tags_de: null,
		content_de: null,
		url: null,
		cover: null,
		category_id: null,
		date_published: null,
		status_id: null,
		author_id: null
	}
}

export const statusList = [
	{
		id: 1,
		name: 'Activo'
	},
	{
		id: 2,
		name: 'Inactivo'
	}
]

export const texts = {
	postEdit: {
		title: 'Editar Entrada Existente',
		subtitle: 'Edita la información de la Entrada.',
		submit: 'Actualizar Entrada',
		messages: {
			success: {
				title: 'ENTRADA ACTUALIZADA',
				text: 'Esta Entrada ha sido actualizada correctamente'
			}
		}
	},
	postNew: {
		title: 'Añadir Nueva Entrada',
		subtitle: 'Crear nueva Entrada',
		submit: 'Crear Entrada',
		messages: {
			success: {
				title: 'ENTRADA CREADA',
				text: 'Se ha creado correctamente la neva Entrada'
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/posts/moks.js